import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { JsonPipe } from '@angular/common';

@Injectable()
export class CommonProjectDataService {
  public shareProjects: any = {};
  public selectedProductColors = {};
  public selectedProductPrice = {};
  public selectedColors: any = [];
  public ownGarmentsWeight: any = {};
  public activeProjectIndex: string;
  public isQuantityValidated = false;
  public totalProjectQuantity: any = [];
  public totalPrice = 0;
  public isLessOrderLimit = 0;
  public minOrderQty = 0;
  public storeInkIDValue: string;
  public storeInkNameValue: string;
  public Inkindex = 0;
  public finishingIndex = 0;
  public isNewQuoteRequest = false;
  public inkTypeLists: Array<any> = [];
  public finishingNo = 0;
  public clientName = '';
  public orderId = '';
  public customOrderId = '';
  public deliveryDate: string;
  public orderType: string;
  public clientId: string;
  public publicUrlToken: string;
  public companyName: string;
  public turnOffPerPiecePrice = false;
  public turnOffImpressionCost = false;
  public turnOffSSInventory = false;
  public storeId: string;
  userDetails = JSON.parse(localStorage.getItem('userDetails'));
  //public storeData: any = {};
  public productIndex = 0;
  public projIndex = 0;
  public storeCheckOutData = {};

  public colorBookList=[];
  public matrixGroupList=[];
  public locationList=[];
  public placementList=[];
  public productMatrix=[];
  public isSaveInstanceState = false;

  public countryList: Array<any> = [
    { countryCode: 'US', countryName: 'United States' },
    { countryCode: 'CA', countryName: 'Canada' }
  ];

  public currentIndexForStep = 0;
  public isInvoiceEditable = 0;
  public scheduledDate: string = ''; 
  public isTaxExempt: string = '0';
  public taxRate = 0;

  constructor() {  }

  taskCount = new BehaviorSubject((this.userDetails && this.userDetails.task_count) ? this.userDetails.task_count : 0);
  receivableCount = new BehaviorSubject((this.userDetails && this.userDetails.receivable_count) ? this.userDetails.receivable_count : 0);
  storeLogo = new Subject();

  getCountryList() {
    return this.countryList;
  }


  store(val) {
    this.shareProjects = val;
  }
  get() {
    return this.shareProjects;
  }

  storeTurnOffPriceView(val) {
    this.turnOffPerPiecePrice = val;
  }
  storeTurnOffImpressionCost(val) {
    this.turnOffImpressionCost = val;
  }

  getTurnOffPriceView() {
    return this.turnOffPerPiecePrice;

  }
  getTurnOffImpressionCost() {
    return this.turnOffImpressionCost;

  }
  storeTurnOffSSInventory(val) {
    this.turnOffSSInventory = val;
  }
  getTurnOffSSInventory() {
    return this.turnOffSSInventory;
  }
  storeCompanyName(val) {
    this.companyName = val;
  }
  getCompanyName() {
    return this.companyName;
  }
  storeOrderType(val) {
    this.orderType = val;
  }
  getOrderType() {
    return this.orderType;
  }

  storeProductColor(val) {
    this.selectedProductColors = val;
  }

  getProductColor() {
    return this.selectedProductColors;
  }

  storeSelectedColor(val) {
    this.selectedColors = val;
  }

  getSelectedColor() {
    return this.selectedColors;
  }

  getOwnGarmentsWeight() {
    return this.ownGarmentsWeight;
  }
  storeOwnGarmentsWeight(val) {
    this.ownGarmentsWeight = val;
  }

  getActiveProjectIndex() {
    return this.activeProjectIndex;
  }

  storeActiveProjectIndex(val) {
    this.activeProjectIndex = val;
  }

  getQuantityValidated() {
    return this.isQuantityValidated;
  }

  storeQuantityValidated(val) {
    this.isQuantityValidated = val;
  }

  getTotalProjectQuantity() {
    return this.totalProjectQuantity;
  }

  storeTotalProjectQuantity(val) {
    this.totalProjectQuantity = val;
  }
  getTotalPrice() {
    return this.totalPrice;
  }

  storeTotalPrice(val) {
    this.totalPrice = val;
  }

  getIsLessOrderLimit() {
    return this.isLessOrderLimit;
  }

  storeIsLessOrderLimit(val) {
    this.isLessOrderLimit = val;
  }
  getMinOrderQty() {
    return this.minOrderQty;
  }

  storeMinOrderQty(val) {
    this.minOrderQty = val;
  }

  getSelectedProductPrice() {
    return this.selectedProductPrice;
  }

  storeSelectedProductPrice(val) {
    this.selectedProductPrice = val;
  }
  getInkId() {
    return this.storeInkIDValue;
  }
  storeInkId(val) {
    this.storeInkIDValue = val;
  }
  getInkName() {
    return this.storeInkNameValue;
  }
  storeInkName(val) {
    this.storeInkNameValue = val;
  }
  getInkIndex() {
    return this.Inkindex;
  }

  storeInkIndex(val) {
    this.Inkindex = val;
  }
  getFinishingIndex() {
    return this.finishingIndex;
  }
  storeFinishingIndex(val) {
    this.finishingIndex = val;
  }

  storeQuoteRequest(val) {
    this.isNewQuoteRequest = val;
  }
  getQuoteRequest() {
    return this.isNewQuoteRequest;
  }

  storeInkTypeRequest(val) {
    this.inkTypeLists = val;
  }
  getInkTypeRequest() {
    return this.inkTypeLists;
  }

  storeFinishingCount(val) {
    this.finishingNo = val;
  }
  getFinishingCount() {
    return this.finishingNo;
  }
  storeClientId(val) {
    this.clientId = val;
  }
  getClientId() {
    return this.clientId;
  }
  getPublicUrlToken() {
    return this.publicUrlToken
  }
  storePublicUrlToken(val) {
    this.publicUrlToken = val;
  }

  getNewUid() {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 18; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[18] = hexDigits.substr((s[18] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = "-";
    return s.join("");
  }
  storeClientName(val) {
    this.clientName = val;
  }
  getclientName() {
    return this.clientName;
  }
  storeOrderId(val) {
    this.orderId = val;
  }
  getOrderId() {
    return this.orderId;
  }
  storeCustomOrderId(val) {
    this.customOrderId = val;
  }
  getCustomOrderId() {
    return this.customOrderId;
  }
  storeStoreId(val) {
    this.storeId = val;
  }
  getStoreId() {
    return this.storeId;
  }
  storeDeliveryDate(val) {
    this.deliveryDate = val;
  }
  getDeliveryDate() {
    return this.deliveryDate;
  }
  storeActiveProductIndex(prodIndex) {
    this.productIndex = prodIndex;
  }
  getActiveProductIndex() {
    return this.productIndex;
  }
  storeActiveProject(projIndex) {
    this.projIndex = projIndex;
  }
  getActiveProject() {
    return this.projIndex;
  }
  storeCheckOut(val) {
    this.storeCheckOutData = val;
  }
  getStoreCheckOut() {
    return this.storeCheckOutData;
  }
  storeColorBook(val)
  {
    this.colorBookList=val;
  }
  getColorBook(){
    return this.colorBookList;
  }
  storeMatrixGroup(val)
  {
    this.matrixGroupList=val;
  }
  getMatrixGroup(){
    return this.matrixGroupList;
  }
  storeLocation(val)
  {
    this.locationList=val;
  }
  getLocation(){
    return this.locationList;
  }
  storePlacementLocation(val)
  {
    this.placementList=val;
  }
  getPlacementLocation(){
    return this.placementList;
  }
  storeCurrentIndexForStep(val){
    this.currentIndexForStep = val;
  }
  getCurrentIndexForStep(){
    return this.currentIndexForStep;
  }
  storeProductMatrix(val){
    this.productMatrix=val;
  }
  getProductMatrix(){
    return this.productMatrix;
  }
  storeIsInvoiceEditable(val){
    this.isInvoiceEditable=val;
  }
  getIsInvoiceEditable(){
    return this.isInvoiceEditable;
  }
  storeScheduledDate(val) {
    this.scheduledDate = val;
  }
  getScheduledDate() {
    return this.scheduledDate;
  }
  storeIsSaveInstanceState(val) {
    this.isSaveInstanceState = val;
  }
  getIsSaveInstanceState() {
    return this.isSaveInstanceState;
  }
  storeIsTaxExempt(val) {
    this.isTaxExempt = val;
  }
  getIsTaxExempt() {
    return this.isTaxExempt;
  }
  storeTaxRate(val) {
    this.taxRate = val;
  }
  getTaxRate() {
    return this.taxRate;
  }
}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/_services/common-project-data.service.ts